import { render, staticRenderFns } from "./OrganizationListItem.vue?vue&type=template&id=fc9b5444"
import script from "./OrganizationListItem.vue?vue&type=script&lang=js"
export * from "./OrganizationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports